module.exports = __webpack_public_path__ + "static/Mari-bbba689efd177e18966a66f9b4ee406f.png";